// extracted by mini-css-extract-plugin
export default {"spinnerPosition":"_1zVZA","signList":"_355oH","signIn":"_3JxeP","registrationBtn":"_1MD3s","signing":"_1eaEZ"};